import { useRef, useState } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';
import { breakpoints } from 'dibs-sassy/exports/breakpoints';

// components
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import HoverableQuestionMarkIcon from './HoverableQuestionMarkIcon';

const messages = defineMessages({
    ccSecAltText: {
        id: 'dc.CreditCardForm.ccSecAltText.placeholder',
        defaultMessage: 'Highlighting the location of the security code on this credit card.',
    },
    ccCardsVMD: {
        id: 'dc.CreditCardForm.ccCardsVMD.placeholder',
        defaultMessage: 'Visa, Mastercard and Discover',
    },
    ccCardsVMDCopy: {
        id: 'dc.CreditCardForm.ccCardsVMDCopy.placeholder',
        defaultMessage: 'Back of the card located to the right of the signature strip',
    },
    ccCardsAmEx: {
        id: 'dc.CreditCardForm.ccCardsAmEx.placeholder',
        defaultMessage: 'American Express',
    },
    ccCardsAmExCopy: {
        id: 'dc.CreditCardForm.ccCardsAmExCopy.placeholder',
        defaultMessage: 'Front of the card, either on the right or left side',
    },
});

const SecurityCodeTooltip = () => {
    const intl = useIntl();
    const [isVisible, setIsVisible] = useState(false);
    const tooltipContainerRef = useRef(null);
    const { ccCardsVMD, ccCardsAmEx, ccCardsVMDCopy, ccCardsAmExCopy, ccSecAltText } = messages;
    const isMobile = window.innerWidth <= breakpoints.mobile.max;

    function toggle() {
        setIsVisible(val => !val);
    }

    function handleTooltipClose(e) {
        if (e && !tooltipContainerRef.current?.contains(e.target)) {
            setIsVisible(false);
        }
    }

    return (
        <div className={styles.tooltip} onClick={toggle} ref={tooltipContainerRef}>
            <HoverableQuestionMarkIcon className={styles.tooltipIcon} />
            <Tooltip
                isVisible={isVisible}
                closeOnOutsideClick
                onClose={handleTooltipClose}
                direction={isMobile ? 'bottom' : 'left'}
            >
                <div className={styles.securityInstructionsWrapper}>
                    <figure className={styles.securityInstructions}>
                        <img
                            className={styles.securityInstructionsImg}
                            src="https://a.1stdibscdn.com/assets/payment-methods/visa_zoom.png"
                            alt={intl.formatMessage(ccSecAltText)}
                            width="122"
                            height="72"
                        />
                        <div className={styles.securityInstructionsTitle}>
                            {intl.formatMessage(ccCardsVMD)}
                        </div>
                        <span className={styles.securityInstructionsText}>
                            {intl.formatMessage(ccCardsVMDCopy)}
                        </span>
                    </figure>
                    <figure className={styles.securityInstructions}>
                        <img
                            className={styles.securityInstructionsImg}
                            src="https://a.1stdibscdn.com/assets/payment-methods/amex_zoom.png"
                            alt={intl.formatMessage(ccSecAltText)}
                            width="120"
                            height="73"
                        />
                        <div className={styles.securityInstructionsTitle}>
                            {intl.formatMessage(ccCardsAmEx)}
                        </div>
                        <span className={styles.securityInstructionsText}>
                            {intl.formatMessage(ccCardsAmExCopy)}
                        </span>
                    </figure>
                </div>
            </Tooltip>
        </div>
    );
};

export default SecurityCodeTooltip;
